(function ($, Drupal, once) {
  Drupal.behaviors.splide = {
    attach: function (context, settings) {
      // JS function for focustrapping
      function focusTrap(modal_id) {
        // add all the elements inside modal which you want to make focusable
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const modal = document.getElementById(modal_id); // select the modal by it's id

        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        const focusableContent = modal.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

        document.addEventListener('keydown', function (e) {
          let isTabPressed = e.key === 'Tab' || e.code === 9;

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
              lastFocusableElement.focus(); // add focus for the last focusable element
              e.preventDefault();
            }
          }
          else if (!e.shiftKey) { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
              firstFocusableElement.focus(); // add focus for the first focusable element
              e.preventDefault();
            }
          }
        });

        firstFocusableElement.focus();
      }

      // Function for checking if keypress is being used for navigation
      function a11yClicked(event) {
        if (event.type === 'click') {
          return true;
        }
        else if (event.type !== 'click') {
          let code = event.which;
          if ((code === 32) || (code === 13)) {
            return true;
          }
        }
        else {
          return false;
        }
      }

      // Basic Splide configuration
      function createCarousel($block) {
        const $carousel_id = $block.find('.splide').first().attr('id');
        const $thumbnail_id = $block.find('.splide').last().attr('id');

        let main_carousel = new Splide('#' + $carousel_id, {
          type: 'fade',
          rewind: true,
          pagination: false,
          heightRatio: 0.62,
          arrows: false
        });

        let carousel_thumbnails = new Splide('#' + $thumbnail_id, {
          fixedWidth: 200,
          fixedHeight: 152,
          gap: 15,
          rewind: true,
          pagination: false,
          isNavigation: true,
          arrows: true,
          breakpoints: {
            576: {
              fixedWidth: 100,
              fixedHeight: 60,
              gap: 5
            }
          }
        });

        main_carousel.sync(carousel_thumbnails);
        main_carousel.mount();
        carousel_thumbnails.mount();
      }

      once('splide-carousel', '.splide-carousel', context).forEach((element) => {
        createCarousel($(element));
      });

      once('feature-carousel', '.feature-carousel', context).forEach((element) => {
        createCarousel($(element));
      });

      // Basic Splide configuration
      function createVerticalCarousel($block) {
        const $carousel_id = $block.find('.splide').first().attr('id');
        const $thumbnail_id = $block.find('.splide').last().attr('id');

        let main_carousel = new Splide('#' + $carousel_id, {
          type: 'fade',
          rewind: true,
          pagination: false,
          heightRatio: 1,
          arrows: true
        });

        let carousel_thumbnails = new Splide('#' + $thumbnail_id, {
          rewind: true,
          pagination: false,
          isNavigation: true,
          arrows: false
        });

        main_carousel.sync(carousel_thumbnails);
        main_carousel.mount();
        carousel_thumbnails.mount();
      }

      once('splide-carousel-vertical', '.splide-carousel-vertical', context).forEach((element) => {
        createVerticalCarousel($(element));
      });

      // Grid carousel and Modal functionality
      function createGridCarousel($block) {
        const $grid_id = $block.find('.splide').first().attr('id');

        // Initialize the grid carousel
        let main_grid_carousel = new Splide('#' + $grid_id, {
          grid: {
            rows: 3,
            cols: 4,
            gap: {
              row: '20px',
              col: '20px'
            }
          }
        });
        main_grid_carousel.mount(window.splide.Extensions);


        // Modal Logic
        const $modal_id = $block.find('.grid-modal').first().attr('id');
        const $modal_content = $block.find('.grid-modal-content').first();
        const $grid_buttons = $('#' + $grid_id).find('.splide__arrows').first();
        $modal_content.attr('id', 'modal-content-' + $modal_id);
        const $modal = $('#' + $modal_id);
        const $modal_image = $modal.find('img').first();
        const $back_button = $block.find('.grid-back').first();
        const $next_button = $block.find('.grid-next').first();
        let $close_modal = $('.close-grid-modal');
        let $current_image_li = '';

        // Change modal imge src when thumbnail image is clicked
        $('#' + $grid_id).find('.splide__slide--col').each(function () {
          $(this).attr('tabindex', 0);
          $(this).on('click keyup', function (event) {
            if (a11yClicked(event) === true) {
              $('html').addClass('no-scroll');
              let $current_image = $(this).find('img').first();
              $('#' + $grid_id).find('.splide__slide--col').removeClass('current-image');
              $current_image_li = $(this);
              $current_image_li.addClass('current-image');
              $modal_image.attr('src', $current_image.attr('src'));
              $modal_image.attr('alt', $current_image.attr('alt'));
              $modal.addClass('open');
              $grid_buttons.addClass('hidden');
              focusTrap($modal_id);
            }
          });
        });

        $back_button.on('click', function () {
          if ($current_image_li.prev('li').length) {
            $current_image_li.prev('li').trigger('click');
          }
          else if (!$current_image_li.prev('li').length &&
            $current_image_li.parent().prev('ul').length) {
            $current_image_li.parent().prev('ul').find('li').last().trigger('click');
          }
          else if (!$current_image_li.prev('li').length &&
            !$current_image_li.parent().prev('ul').length) {
            $current_image_li.parent().parent().prev('li').find('li').last().trigger('click');
            $('#' + $grid_id).find('.splide__arrow--prev').first().trigger('click');
          }
        });

        $next_button.on('click', function () {
          if ($current_image_li.next('li').length) {
            $current_image_li.next('li').trigger('click');
          }
          else if (!$current_image_li.next('li').length &&
            $current_image_li.parent().next('ul').length) {
            $current_image_li.parent().next('ul').find('li').first().trigger('click');
          }
          else if (!$current_image_li.next('li').length &&
            !$current_image_li.parent().next('ul').length) {
            $current_image_li.parent().parent().next('li').find('li').first().trigger('click');
            $('#' + $grid_id).find('.splide__arrow--next').first().trigger('click');
          }
        });

        $close_modal.on('click', function () {
          $modal.removeClass('open');
          $grid_buttons.removeClass('hidden');
          $('html').removeClass('no-scroll');
        });
      }

      once('modal-gallery', '.modal-gallery', context).forEach((element) => {
        createGridCarousel($(element));
      });

      function testimonialCarousel($block) {
        const $carousel_id = $block.find('.splide').first().attr('id');

        let carousel = new Splide('#' + $carousel_id, {
          type: 'loop',
          pagination: false,
          arrows: true,
          perPage: 1,
          autoplay: true,
          interval: 5000,
          pauseOnHover: false,
          pauseOnFocus: false
        });

        var toggleButton = carousel.root.querySelector('.splide__pause');

        function setAutoplayState() {
          var autoplay = carousel.Components.Autoplay;
          var isPaused = !autoplay || autoplay.isPaused();

          toggleButton.classList.toggle('paused', isPaused);
          toggleButton.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
          toggleButton.setAttribute('aria-label', isPaused ? 'Start autoplay' : 'Pause autoplay');
        }

        if (toggleButton) {
          toggleButton.addEventListener('click', function () {
            var autoplay = carousel.Components.Autoplay;

            if (!autoplay) {
              return;
            }

            if (autoplay.isPaused()) {
              autoplay.play();
            }
            else {
              autoplay.pause();
            }

            setAutoplayState();
          });

          carousel.on('mounted autoplay:play autoplay:pause', setAutoplayState);
        }

        carousel.mount();
      }

      once('testimonials', '.testimonials', context).forEach((element) => {
        testimonialCarousel($(element));
      });

      once('hero-splide', '.hero-splide', context).forEach((element) => {
        const $carousel_id = $(element).find('.splide').first().attr('id');

        let carousel = new Splide('#' + $carousel_id, {
          type: 'loop',
          pagination: true
        });

        carousel.mount();
      });

      once('carousel-default', '.carousel-default', context).forEach((element) => {
        const $carousel_id = $(element).find('.splide').first().attr('id');

        let carousel = new Splide('#' + $carousel_id, {
          type: 'fade',
          rewind: false,
          pagination: true
        });

        carousel.mount();

        function setPagination() {
          var paginationContainer = carousel.root.querySelector('.splide__pagination');
          var paginationDots = carousel.root.querySelectorAll('.splide__pagination__page');
          var activeIndex = carousel.index;

          paginationDots.forEach(function (dot, dotIndex) {
            var distance = Math.abs(dotIndex - activeIndex);
            var size = 1 - Math.min(distance * 0.333, 1);
            dot.style.transform = 'scale(' + size + ')';
          });

          var offset = (activeIndex * -28) + (paginationDots.length * 14) - 9;
          paginationContainer.style.left = offset + 'px';
        }

        setPagination();
        carousel.on('moved', setPagination);
      });

      once('mobile-splide', '.mobile-splide', context).forEach((element) => {
        const $carousel_id = $(element).attr('id');

        let carousel = new Splide('#' + $carousel_id, {
          type: 'slide',
          pagination: false,
          arrows: false,
          mediaQuery: 'min',
          breakpoints: {
            1024: {
              destroy: true
            }
          }
        });

        carousel.mount();
      });
    }
  };
})(jQuery, Drupal, once);